
export enum DownloadResponse {
  TemLink = 'TemLink',
  TahNaFila = 'TahNaFila',
  Filado = 'Filado',
  ZitoDown = 'ZitoDown',
  IntervaloDataExcedido = 'IntervaloDataExcedido',
}
